module.exports = __webpack_public_path__ + "img/business-logo.928587f.png";